import axios from '../../plugins/axios'

export const getOverview = () => {
  return axios.get('/billing/admin/overview/')
    .then(response => response)
    .catch(err => err.response)
}

export const markPaid = (_ctx, { subscriptionId, planId } = {}) => {
  return axios.post(`/billing/admin/subscriptions/${subscriptionId}/mark_paid/`, { plan_id: planId })
    .then(response => response)
    .catch(err => err.response)
}

export const extendSubscription = (_ctx, { subscriptionId, days } = {}) => {
  return axios.post(`/billing/admin/subscriptions/${subscriptionId}/extend/`, { days })
    .then(response => response)
    .catch(err => err.response)
}

export const suspendSubscription = (_ctx, { subscriptionId } = {}) => {
  return axios.post(`/billing/admin/subscriptions/${subscriptionId}/suspend/`)
    .then(response => response)
    .catch(err => err.response)
}

export const activateSubscription = (_ctx, { subscriptionId } = {}) => {
  return axios.post(`/billing/admin/subscriptions/${subscriptionId}/activate/`)
    .then(response => response)
    .catch(err => err.response)
}

export const setPlan = (_ctx, { subscriptionId, planId } = {}) => {
  return axios.post(`/billing/admin/subscriptions/${subscriptionId}/set_plan/`, { plan_id: planId })
    .then(response => response)
    .catch(err => err.response)
}

// --- Gestión de usuarios ---
export const getUsers = () => {
  return axios.get('/billing/admin/users/')
    .then(response => response)
    .catch(err => err.response)
}

export const createUser = (_ctx, data = {}) => {
  return axios.post('/billing/admin/users/', data)
    .then(response => response)
    .catch(err => err.response)
}

export const updateUser = (_ctx, { id, ...data } = {}) => {
  return axios.patch(`/billing/admin/users/${id}/`, data)
    .then(response => response)
    .catch(err => err.response)
}

export const resetUserPassword = (_ctx, { id, password } = {}) => {
  return axios.post(`/billing/admin/users/${id}/reset_password/`, password ? { password } : {})
    .then(response => response)
    .catch(err => err.response)
}

// --------------------------------------------------------------------------- //
//  Pagos por validar (transferencias y links de Flow)
//  El backend expone estos endpoints desde el principio, pero el panel nunca los
//  usó: una compra por transferencia quedaba esperando validación sin aparecer en
//  ninguna pantalla.
// --------------------------------------------------------------------------- //

export const getPendingTransfers = (_ctx, { all = false } = {}) => {
  return axios.get('/billing/admin/pending/', { params: all ? { all: 1 } : {} })
    .then(response => response)
    .catch(err => err.response)
}

export const approveTransfer = (_ctx, { id } = {}) => {
  return axios.post(`/billing/admin/pending/${id}/approve/`)
    .then(response => response)
    .catch(err => err.response)
}

export const rejectTransfer = (_ctx, { id, reason } = {}) => {
  return axios.post(`/billing/admin/pending/${id}/reject/`, { reason })
    .then(response => response)
    .catch(err => err.response)
}

// --------------------------------------------------------------------------- //
//  Empresas: crear suscripción y borrado definitivo
// --------------------------------------------------------------------------- //

// Para empresas sin suscripción, que antes quedaban sin ninguna acción posible.
export const createSubscription = (_ctx, { businessId, planId } = {}) => {
  return axios.post(`/billing/admin/businesses/${businessId}/create_subscription/`, { plan_id: planId })
    .then(response => response)
    .catch(err => err.response)
}

// Irreversible y en cascada. El backend exige repetir el nombre exacto.
export const deleteBusiness = (_ctx, { businessId, confirmName } = {}) => {
  return axios.delete(`/billing/admin/businesses/${businessId}/`, { data: { confirm_name: confirmName } })
    .then(response => response)
    .catch(err => err.response)
}
